<template>
  <table class="table">
    <thead>
      <tr>
        <th>#</th>
        <th>Item</th>
        <template v-if="isCommission">
          <th>Booking amount</th>
          <th>Commission amount</th>
          <th>Company amount</th>
        </template>
        <th>Amount</th>
      </tr>
    </thead>
    <tr v-for="(item, i) in order.items" :key="i">
      <td>{{ i + 1 }}</td>
      <td>{{ item.description }}</td>
      <template v-if="isCommission">
        <td>
          {{ item.params.booking_amount | currency(order.currency_label) }}
        </td>
        <td>
          {{ item.params.commission_amount | currency(order.currency_label) }}
        </td>
        <td>
          {{ item.params.company_amount | currency(order.currency_label) }}
        </td>
      </template>
      <td>{{ item.amount | currency(order.currency_label) }}</td>
    </tr>
  </table>
</template>

<script>
export default {
  name: 'OrderItems',
  props: {
    order: {
      type: Object,
      required: true,
    },
  },

  computed: {
    isCommission: function isCommission() {
      return ['commission', 'payout'].includes(this.order.category)
    },
  },
}
</script>
